export default function auth({
    next,
    router
}) {
    if (!localStorage.getItem('isVerified')) {
        let hostDestination =
            window.location.hostname === "localhost" ?
            `localhost:${window.location.port}` :
            window.location.hostname;

        window.location.href = `http://${hostDestination}`;
    } else if (localStorage.getItem('isVerified') == 'false' || !localStorage.getItem('isVerified')) return router.push(`/email-verify/${localStorage.getItem('id')}`);
    return next();
}